import * as Actions from '../../actions';

const initialState = { data: null };

const driverStatsReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_DRIVER_STATS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default driverStatsReducer;
